// extracted by mini-css-extract-plugin
export default {"countContainer":"ProductTableCountCellView_countContainer__FdvVu"};